import React, {useState} from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import commaNumber from "comma-number";
import _ from "lodash";
import dayjs from "dayjs";

const format = commaNumber.bindWith(",", ".");

const EmiDueTable = () => {
  const { list, loading } = useSelector((state) => state.emiDue);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "EMI No", dataIndex: "emi_no", width: 100 },
    { title: "Customer Name", dataIndex: "acc_name", width: 150 },
    { title: "Contact", dataIndex: "contact_no", width: 120 },
    {
      title: "From Date",
      dataIndex: "from_date",
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY") : "-"),
      width: 100,
    },
    {
      title: "Last Date",
      dataIndex: "last_date",
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY") : "-"),
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120,
    },
  ];

  const totalAmount = _.sumBy(list, (acc) => Number(acc.amount || 0));

  return (
    <Table
      rowKey="emi_no"
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={{ x: "max-content" }}
      size="middle"
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={6} align="right">
            <strong>Grand Total:</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            <strong>{format(totalAmount.toFixed(2))}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default EmiDueTable;
